import { render, staticRenderFns } from "./StudentSignUpAddEdit.vue?vue&type=template&id=1c08f6b4"
import script from "./StudentSignUpAddEdit.vue?vue&type=script&lang=js"
export * from "./StudentSignUpAddEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports